import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from './Containers/Home'
import FaqPage from './Containers/FaqPage'
import './App.css';
import Footer from './components/Footer'

function App() {
  return (
    <Router>
      {/* <Header /> */}
      <Switch>
        <Route exact path="/faq" component={FaqPage} />
        {/* <Route exact path="/apply" component={ApplyNowPage} /> */}
        <Route path="/" component={Home} />
      </Switch>
      <Footer />
    </Router>
  );
}

export default App;
